export const SEND_MESSAGE = 'SEND_MESSAGE';
export const GET_TOKEN_METAMASK = 'GET_TOKEN_METAMASK';
export const GET_TOKEN_WALLID = 'GET_TOKEN_WALLID';
export const GET_TOKEN_WALLET = '/tsp/verifyWallet/challenge';
export const VERIFY_WALLET = '/verifyWallet/verify';
export const START_TSP = '/startTSP';
export const VERIFY_DATA_ID = '/verifyDataID';
export const HANDLE_ASSETS = 'HANDLE_ASSETS';
